import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const useCollection = (resource) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    api.get(`/public/${resource}`).then((r) => { if (alive) setItems(r.data || []); }).catch(() => {}).finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [resource]);
  return { items, loading };
};
